'use strict';

module.exports = function (ngModule) {
    require('./orderobjectby')(ngModule);
    require('./makerange')(ngModule);
}


/** WEBPACK FOOTER **
 ** ./src/pages/filters/index.js
 **/